import api from "../api";

export interface StripeAccount {
    id: number;
    user_id: number;
    stripe_account_id: string;
    charges_enabled: boolean;
    payouts_enabled: boolean;
    details_submitted: boolean;
    created_at: string;
    updated_at: string;
}

export const stripeConnectService = {
    createAccount: async (): Promise<{ stripe_account: StripeAccount }> => {
        const response = await api.post("/stripe-connect/account");
        return response.data;
    },

    getOnboardingLink: async (): Promise<{ url: string }> => {
        const response = await api.get("/stripe-connect/onboarding-link");
        return response.data;
    },

    getAccountStatus: async (): Promise<{ stripe_account: StripeAccount }> => {
        const response = await api.get("/stripe-connect/status");
        return response.data;
    },

    createAccountSession: async (): Promise<{ client_secret: string }> => {
        const response = await api.post("/stripe-connect/account-session");
        return response.data;
    },
};
